import { action } from 'satcheljs';
import type { AttachmentFileList, CreateAttachmentsProperties } from 'owa-attachment-well-data';

export const createAttachmentsFromFiles = action(
    'createAttachmentsFromFiles ',
    (fileList: AttachmentFileList, properties: CreateAttachmentsProperties, formId: string) => ({
        fileList,
        properties,
        formId,
    })
);
